export const HOTSPOT_QUESTION_ANSWER = 'HOTSPOT_QUESTION_ANSWER';

export const hotspotQuestionAnswer = (data, questionId) => dispatch => {
  dispatch({
    type: HOTSPOT_QUESTION_ANSWER,
    payload: { data, questionId }
  });
};
